<template>
  <v-container fluid>
    <employee-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      EmployeeReportContainerView: () => import('@/components/hris/reports/employee/EmployeeReports'),
    },
  }
</script>
